import { Outlet } from "react-router-dom";
import SlideBar from "../../Components/SlideMenu";
import ChatBox from "../../Components/Chatbox/chatbox";
import Footer from "../../Components/Footer/footer";
import Header from "../../Components/Header/header";
import PrivateRoute from "../../Components/Routes/Components/PrivateRoute"
import NewSlideBar from "../../Components/NewSlideMenu";



function DashboardLayout () { 
  return(
    <>
      {/*<div id="main-wrapper" >*/}
      <PrivateRoute>
        <div>
        <Header />
        <ChatBox />
        {/* <SlideBar /> */}
        <NewSlideBar />
        <Outlet />
        
        <Footer />
        </div>
      </PrivateRoute>
    
    </>
  )
}

export default DashboardLayout;  